import {
  SAVE_APP_ID,
  } from '../../Constants/Type';
  
  export const saveOperaAppId = text => ({
    type: SAVE_APP_ID,
    payload: text
  });
  